/**
 * Primitive constants for the application.
 * These are used to define the basic colors and styles for the application.
 * These should be synced automatically from figma at some point.
 *
 * figma: https://www.figma.com/design/C252J5XoQK9gCvWv0x15NQ/Nodon-Design-System?node-id=1123-3566&m=dev
 */
export const Primitives = {
  colors: {
    transparent_gray: {
      50: 'rgba(0,0,0,0.1)',
      100: 'rgba(0,0,0,0.2)',
      200: 'rgba(0,0,0,0.3)',
      400: 'rgba(0,0,0,0.5)',
      600: 'rgba(0,0,0,0.7)',
      800: 'rgba(0,0,0,0.8)',
      black: 'rgba(0,0,0,1)',
    },
    activites: {
      green: 'rgba(197, 224, 216, 1)',
      orange: 'rgba(243, 214, 202, 1)',
      red: 'rgba(219, 184, 189, 1)',
    },
    warm_surface: {
      main: '#F8F6F3',
      /** A shade deeper than main — chrome around a warm surface, e.g. the report thumbnail panel. */
      dark: '#EFEDE9',
    },
  },
} as const;
